
<template>
  <div name="schools" class="extra-curricular pb-10">
    <header class="inner-head border-transparent">
      <div class="flex justify-between">
        <h2 class="inner-head-title">{{title}} List</h2>
      </div>
    </header>

    <div
      class="header-subnav-holder">
      <button
        v-for="type in typeList"
        :key="type.key"
        type="button"
        class="header-subnav focus:outline-none"
        @click="userDidSelectType(type)"
        v-bind:class="[typeSelected.key == type.key ? 'selected' : '']"
      >
        {{ type.name }}
      </button>
    </div>

        <div class="row bg-white w-95p mx-auto">
          <div class="col-md-12">
        
                <!-- Section -->
                <section class="card">
                  
              <div class="card-body">
                <div class="table-responsive">

                  <ul class="buttons">
                     <li>
                      <button type="button" class="p-2" v-for="letter in letters" :key="letter" 
                      v-bind:class="checkLetter(letter)"  @click="letterSelect(letter)"  > 
                          {{ letter.name }}
                          </button>
                      </li>
                      <li class="ml-4">
                            <input type="text" class="" name="search" 
                            v-model="search" placeholder="Enter search term..." style="width:20em;">
                      </li>
                    </ul>

      


                </div>
              </div>
            </section>
                <!-- Schools display -->

               

                 <section class="card">
                      <div class="card-body">
                <div class="table-responsive">

                  <div v-if="errored" class="empty">
                    <p>We are not able to retrieve this information at the moment, please try back later</p>
                  </div>

                <div id="content-area" v-else>
                  <div style="width:100%; text-align:center;" v-if="loading" >
                    <i class="spinner fa fa-spinner fa-spin"></i>
                  </div>

                    <div class="mt-6" v-else>
                      <h4>Total: <strong>{{total}}</strong> schools in view</h4>
                     
                            <table class="table-wrapper w-full bg-white mx-auto mt-2 rounded shadow-sm" v-if="componentLoaded">
                              <thead class="text-primary">
                                <tr>
                                  <th width="55%" class="align-left">Name</th>
                                  <th width="15%">Postcode</th>
                                  <th width="8%">Active</th>
                                  <th width="12%"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="course" v-for="item in filteredList" :key="item.id"> 
                                   <td>
                                    <strong>{{ item.name }}</strong>
                                  </td>
                                  <td >{{ item.postcode }}</td>
                                  
                                   <td align="center" >
                                    <i class="icon list"  v-bind:class="setActiveClass(item.active)" />
                                   </td>
                                  <td align="center" class="tb-actions">
                                    <a v-on:click="viewSchool(item)" class="text-button orange-text">View</a>
                                  </td>
                                </tr>
                               
                              </tbody>
                              <tfoot>

                              </tfoot>
                            </table>

                             <p class="empty" v-else>We could not find any data for your given selection.</p>
                         
                      </div>
                </div>

              </div>

            </div>

             </section>

     </div>

   </div>


  </div>

</template>

<script>
//import { mapGetters } from 'vuex'

import { BaseService } from "@/services/school.service";


const dropdown = () => import('@/components/admin/Dropdown.vue')
const noaccess = () => import('@/components/admin/NoAccess.vue')
const filterbar = () => import('@/components/admin/FilterBar.vue')
import { yearList } from '@/assets/js/utils';

export default {
  name: 'schools',
 props: [],
 computed: {
   // ...mapGetters({ currentUser: 'currentUser', currentAccess: 'currentAccess' }),
    componentLoaded () {
      return this.filteredList.length > 0
    },
    title() {
      return this.typeSelected.name
    },
    // Function for correctly ordering the schools by name
    orderedSchools () {
      var vm = this;
      var active = vm.selectedActive.id
      var letters = vm.selectedLetters;

      if (letters.length == 0 && active == 2) {
        return _.orderBy(this.schools, ['name'])
      } else {
          var filtered = vm.schools.filter(function(item) {
            let filtered = true
              if (active < 2) {
                return item.active == active
              }

              if (letters.length > 0) {
                return letters.includes(item.name.charAt(0).toLowerCase())
              }

            return filtered;
        });
        
        return _.orderBy(filtered, ['name'])
      }
      
    },
    total () {
      return this.filteredList.length
    },
    filteredList() {
       return this.orderedSchools.filter(item => {
         var vm = this;
         return item.name.toLowerCase().includes(vm.search.toLowerCase())
       })
   },
  },
  data () {
    return {
      loading: false,
      errored: false,
      typeSelected: null,
      newToken: '',
      schools: [],
      typeList: [
        {key: "trial", name: "Trial"},
        {key: "subscribed", name: "Primary"},
        {key: "secondary", name: "Secondary"},
        {key: "international", name: "International"},
      ],
      actives: [
        {id: 2, name: "All Schools"}, 
        {id: 1, name: "Currently Active"}, 
        {id: 0, name: "Hidden"}],
      letters: [
        {name: "A"}, {name: "B"}, {name: "C"}, {name: "D"}, {name: "E"}, {name: "F"},
        {name: "G"}, {name: "H"}, {name: "I"}, {name: "J"}, {name: "K"}, {name: "L"}, {name: "M"}, {name: "N"}, {name: "O"},
        {name: "P"}, {name: "Q"}, {name: "R"}, {name: "S"}, {name: "T"}, {name: "U"}, {name: "V"}, {name: "W"}, {name: "X"},
        {name: "Y"}, {name: "Z"}
      ],
      selectedActive: {},
      selectedLetters: [],
      search: '',
      fields: [
        {
          name: 'name',
          sortField: 'name'
        }
      ],
    }
  },
  created() {
    this.typeSelected = this.typeList[0]
  },
  mounted () {
    this.loading = true
    this.fetchData()
  },
  beforeRouteUpdate (to, from, next) {
    next();
  },
  methods: {
    fetchData () {
      BaseService.getAll('archon/office/schools?types=' + this.typeSelected.key )
        .then(response => this.buildSchoolList(response.data.data))
        .catch((err) => { 
          console.log('Schools ' + err); 
          this.errored = true
        })
        .finally(() => this.loading = false)
    },
    buildSchoolList (data) {
      this.schools = data
    },

    refreshUnits () {
      this.fetchData()
    },
    viewSchool (school) {
      this.$router.push({
        name: "RegistersAdmin",
        params: { school: school }
      });

      
    },
    setActiveClass (active) {
      if (active == 1) {
        return 'fas fa-check-circle active-true'
      } else {
        return 'fas fa-times-circle active-false'
      }
    },

    activeSelect (active) {
      var vm = this;
      vm.selectedActive = active;
    },

    letterSelect (letter) {
      let name = letter.name.toLowerCase()
      if (this.selectedLetters.includes(name)) {
          this.selectedLetters.splice(this.selectedLetters.indexOf(name), 1);
      } else {
        this.selectedLetters.push(name);
      }
    },
    checkLetter (letter) {
       return (this.selectedLetters.includes(letter.name.toLowerCase())) ? "on" : ""
    },
    userDidSelectType(type) {
      this.typeSelected = type
      this.fetchData()
    }
 },
  components: {
    dropdown,
    noaccess,
    filterbar
  },
}
</script>


<style scoped>
table td {
  padding-top: 0.5em !important;
  padding-bottom: 0.5em !important;
}

  .spinner {
    color: #f56a6a !important;
    font-size: 14em;
  }

  .tb-actions a {
   cursor: pointer !important;
  }

  .orange {
    color: orange;
  }

  .alphabet-search {
    display: flex;
    width: 100%;
    justify-content: space-evenly;
    height: 30%;
    margin: 0 auto;
  }

  .alphabet-letter {
    cursor: pointer;
    text-decoration: underline !important;
  }


.card-header ul {
  width: 50%;
  float:right;
  right:0;
  text-align: right !important;
 }

.card-header ul li {
  display: inline-block;
  padding-right: 17px;
}

.card-header ul li a:hover {
  opacity: 0.7 !important;
}

/*****************************
 **** Filter
 ***************************/

 ul.filter {
  width: 100%;
 }
 
  .filter li {
    width: 30%;
    padding-right: 0em !important;
      display: inline-block;
  }

  .filter li:first-of-type {
    width: 17%;
  }


  ul.buttons li  {
     display: inline-block;
  }

    ul.buttons li button {
      margin: 4px;
      border-width: 1px;
      cursor: pointer;
    }

    ul.buttons li button:hover {
      opacity: 0.7 !important;
    }

    ul.buttons li button.on {
       background-color: #e14eca !important;
       border-color: #e14eca !important;
       color: #fff;
    }

    


</style>
